<template>
  <b-container>
    <b-card no-body class="mt-3">
      <b-tabs card v-model="tabIndex">
        <b-tab title="All Modules">
          <div v-if="getModules.length>0">
            <b-table responsive striped hover :items="getModules" :fields="fields">
              <template v-slot:cell(#)="data">{{data.index + 1}}</template>
              <template v-slot:cell(module_name)="data">{{data.item.name}}</template>
              <template v-slot:cell(language)="data">{{data.item.language}}</template>
              <template v-slot:cell(action)="data">
                <b-button size="sm" variant="info" class="mr-2" @click="editModule(data.item)">Edit</b-button>
                <b-button size="sm" variant="danger" @click="deleteModule(data.item)">Delete</b-button>
              </template>
            </b-table>
          </div>
        </b-tab>
        <b-tab title="Add New Module">
          <div>
            <b-row>
              <b-col sm="12" md="3" lg="3">Enter Module Name :</b-col>
              <b-col sm="12" md="3" lg="3">
                <b-form-input v-model="moduleName" placeholder="Enter your name"></b-form-input>
              </b-col>
              <b-col sm="12" md="3" lg="3">
                <b-form-select v-model="selectedLanguage">
                  <option v-for="lang in languages" :key="lang.code" :value="lang">{{ lang.name }}</option>
                </b-form-select>
              </b-col>
              <b-col sm="12" md="3" lg="3">
                <b-button @click="addModule" variant="primary">Add Module</b-button>
              </b-col>
            </b-row>
          </div>
        </b-tab>
      </b-tabs>
    </b-card>
  </b-container>
</template>

<script>
import { db } from "../../db";
import { languages } from "../../utils/constants";
export default {
  data() {
    return {
      tabIndex: 0,
      fields: [
        { key: "#", sortable: false },
        { key: "module_name", sortable: false },
        { key: "language", sortable: true },
        { key: "action", sortable: false }
      ],
      languages: languages,
      selectedLanguage: null,
      moduleName: "",
      updateOperation: false,
      moduleId: ""
    };
  },

  computed: {
    getModules() {
      return this.$store.getters.getModules;
    }
  },

  created() {
    if (this.$store.getters.getModules.length == 0) {
      this.$store.dispatch("setModules");
    }
  },
  methods: {
    addModule() {
      if (
        this.moduleName.trim() !== "" &&
        this.selectedLanguage.name.trim() !== ""
      ) {
        if (!this.updateOperation) {
          db.collection("modules").add({
            name: this.moduleName,
            language: this.selectedLanguage.name
          });
        } else {
          db.collection("modules")
            .doc(this.moduleId)
            .update({
              name: this.moduleName,
              language: this.selectedLanguage.name
            });
        }
        this.$store.dispatch("setModules");
        this.resetValues();
      } else {
        alert("Please Enter Module Name and Select language ");
      }
    },
    editModule(value) {
      this.tabIndex = 1;
      this.moduleName = value.name;
      this.selectedLanguage = languages.find(language => {
        return language.name == value.language;
      });
      this.updateOperation = true;
      this.moduleId = value.id;
    },
    deleteModule(data) {
      this.$swal
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete it!"
        })
        .then(result => {
          if (result.value) {
            db.collection("modules")
              .doc(data.id)
              .delete();

            this.$store.dispatch("setModules");
          }
        });
    },
    resetValues() {
      this.moduleName = "";
      this.selectedLanguage = null;
      this.tabIndex = 0;
    }
  }
};
</script>